import { obtenerValoresFiltros } from "../../../../global/js/funciones";

 export const cargarCatalogo = async (tipo, setState) => {
        try {
            const data = await obtenerValoresFiltros([
                { llave: 'generica', valor: tipo },
                { llave: 'estado', valor: 1 }
            ]);
            const opciones = (Array.isArray(data) ? data : []).map(item => ({
                value: item.id || item.codigo || item.valor,
                label: item.nombre || item.valor || item.label || ""
            }));
            setState(opciones);
        } catch (error) {
            console.error(`Error cargando ${tipo}:`, error);
        }
    };